import {CandidateList} from "./CandidateList";
import {CandidateEdit} from "./CandidateEdit";
import {CandidateCreate} from "./CandidateCreate";

export default {
    list: CandidateList,
    create: CandidateCreate,
    edit: CandidateEdit
};
